import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { LoadingScreen } from "../../../Components";
import { useTodoList } from "../../../Constant/apiHooks";
import { newAuthService } from "../../../Service/Axios";
import {
  DASHBOARD_DELETE_TODO_URL,
  DASHBOARD_SAVE_TODO_URL,
} from "../../../Constant/api";
import {
  formatDateLocal,
  formatDateWithShortMonth,
  getCurrentWeekList,
} from "../../../Utils";

const assignslider = {
  infinite: false,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 1360,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 375,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
};

export const Todos = () => {
  const { t } = useTranslation();

  const [isAddTodo, setIsAddTodo] = useState(false);
  const [isEditTodo, setIsEditTodo] = useState(false);
  const [activeTodoDate, setActiveTodoDate] = useState(
    formatDateLocal(new Date())
  );

  const [formData, setFormData] = useState({
    todoGid: "",
    title: "",
    description: "",
    dueDate: "",
    remainder: true,
    subTask: "",
    pin: false,
    focusMode: false,
  });
  const {
    todoGid,
    title,
    description,
    dueDate,
    remainder,
    subTask,
    pin,
    focusMode,
  } = formData;

  const {
    todoList,
    loading: todoLoading,
    fetchTodoList,
  } = useTodoList(focusMode ? activeTodoDate : undefined);

  // Toggle
  const toggleAddTodo = () => {
    setIsAddTodo(!isAddTodo);
    setIsEditTodo(false);
  };
  const toggleEditTodo = (todo) => {
    setIsEditTodo(!isEditTodo);
    setIsAddTodo(false);
    if (todo) {
      setFormData((prev) => ({
        ...prev,
        todoGid: todo.gid,
        title: todo.name,
        description: todo.description,
        dueDate: formatDateLocal(todo.dueDate),
        remainder: todo.reminder,
        subTask: todo.subtask,
        pin: todo.pin,
      }));
    }
  };

  const toggleTodoList = (date) => {
    setActiveTodoDate(date);
  };

  // On Change
  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleChangePin = () => {
    setFormData((prev) => ({
      ...prev,
      pin: !prev.pin,
    }));
  };

  // Todo
  const onSaveTodo = async () => {
    const payload = {
      gid: todoGid,
      name: title,
      description: description,
      dueDate,
      reminder: remainder,
      subtask: subTask,
      pin,
    };
    await newAuthService(DASHBOARD_SAVE_TODO_URL, "POST", payload);
    onResetTodo();
    fetchTodoList(focusMode ? activeTodoDate : undefined);
  };

  const onResetTodo = () => {
    setFormData((prev) => ({
      ...prev,
      todoGid: "",
      title: "",
      description: "",
      dueDate: "",
      remainder: true,
      subTask: "",
      pin: false,
      focusMode: false,
    }));
    setIsAddTodo(false);
    setIsEditTodo(false);
  };

  const onDeleteTodo = async () => {
    const payload = {
      gid: todoGid,
    };
    await newAuthService(DASHBOARD_DELETE_TODO_URL, "POST", payload);
    onResetTodo();
    fetchTodoList(focusMode ? activeTodoDate : undefined);
  };

  return (
    <>
      {!isAddTodo && !isEditTodo && (
        <div className="task-box h-100 p-3 rounded-md border bg-white d-flex flex-column row-gap-2">
          <div className="d-flex flex-wrap align-items-center">
            <h3 className="mb-0 text-base font-semibold text-grey-900">{t("auth.dashboard.taskList.title")}</h3>

            <div className="ms-auto d-flex align-items-center">
              <i className="bx bx-calendar bx-sm"></i>
              <div className="focus-switch form-check form-switch d-flex align-items-center">
                <label className="form-check-label me-2" htmlFor="focusMode">
                  {t("auth.dashboard.taskList.focusMode")}
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="focusMode"
                  name="focusMode"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="card-body">
            {todoLoading ? (
              <LoadingScreen />
            ) : (
              <>
                {focusMode && (
                  <div className="calender-list">
                    <Slider {...assignslider}>
                      {getCurrentWeekList().map((date, index) => (
                        <div
                          className={`date-box bg-white p-2 text-center rounded-3 shadow-sm ${
                            `${date.localDate}` === activeTodoDate
                              ? "active"
                              : ""
                          }`}
                          key={index.toString()}
                          onClick={() => toggleTodoList(date.localDate)}
                        >
                          <div className="month">{date.month}</div>
                          <div className="day">{date.date}</div>
                          <div className="week">{date.day}</div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                )}

                <ul className="assign-task-list mb-3">
                  {todoList &&
                    todoList.length > 0 &&
                    todoList.map((todo, index) => (
                      <li key={index.toString()}>
                        <div className="assign-task-box py-2 px-3 d-flex align-items-center gap-1 rounded-3">
                          <input type="checkbox" />
                          <span className="font-medium">{todo.name}</span>
                          <span className="badge text-xs font-medium text-green-500 border border-green-200 bg-green-50">Today</span>
                          {formatDateLocal(new Date()) ===
                            formatDateLocal(todo.dueDate) && (
                            <span className="assign-date badge text-bg-success ms-3">
                              {t("common.today")}
                            </span>
                          )}
                          <div className="button-list ms-auto d-flex align-items-center">
                            <button
                              type="button"
                              className="button edit-button bg-transparent border-0"
                              onClick={() => toggleEditTodo(todo)}
                            >
                              <i className="bx bxs-pencil"></i>
                            </button>
                            <button
                              type="button"
                              className={`button pin-button bg-transparent border-0 ${
                                todo.pin ? "active" : ""
                              }`}
                            >
                              <i className="bx bxs-pin"></i>
                            </button>
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
              </>
            )}
          </div>
          <button type="button" className="task-btn" onClick={toggleAddTodo}>
            <i className="bx bx-plus"></i>
          </button>
        </div>
      )}

      {isEditTodo && !isAddTodo && (
        <div className="card custom-card card-shadow rounded-2 border-0 mb-4">
          <div className="card-header d-flex flex-wrap align-items-center mb-2">
            <button
              type="button"
              className="bg-transparent border-0 me-2"
              onClick={onResetTodo}
            >
              <i className="bx bxs-left-arrow"></i>
            </button>
            <h3 className="card-title font-semibold">{title}</h3>
            <div className="ms-auto d-flex align-items-center">
              <button
                type="button"
                className={`pin-button bg-transparent border-0 ms-auto ${
                  pin ? "active" : ""
                }`}
                onClick={handleChangePin}
              >
                <i className="bx bxs-pin"></i>
              </button>
            </div>
          </div>
          <div className="card-body">
            <div className="assigntask-header mb-3">
              <ul className="m-0 p-0 d-flex flex-wrap gy-3">
                <li className="assigntask-box d-flex align-items-center me-4">
                  <div className="assigntast-icon d-flex justify-content-center align-items-center me-2">
                    <i className="bx bx-calendar bx-sm"></i>
                  </div>
                  <div className="assigntast-content">
                    <span className="assigntask-title d-block">
                      {t("common.label.dueOn")}
                    </span>
                    <h4>{formatDateWithShortMonth(dueDate)}</h4>
                  </div>
                </li>
                <li className="assigntask-box d-flex align-items-center">
                  <div className="assigntast-icon d-flex justify-content-center align-items-center me-2">
                    <i className="bx bx-bell bx-sm"></i>
                  </div>
                  <div className="assigntast-content">
                    <span className="assigntask-title d-block">
                      {t("common.label.reminder")}
                    </span>
                    <h4>{remainder ? "Yes" : "No"}</h4>
                  </div>
                </li>
              </ul>
            </div>
            <div className="assigntask-body mb-3">
              <div className="mb-4 p-3 rounded-3 bg-light">
                <p>{description}</p>
              </div>
              <div className="add-sub-task-box">
                <h5>{t("common.label.subTask")}</h5>
                <div className="select-subtask px-3 py-2 bg-light">
                  <span>{subTask}</span>
                </div>
              </div>
            </div>
            <div className="assigntask-footer d-flex justify-content-center">
              <div className="py-2 px-3 rounded-3 bg-dark text-white text-center">
                <button
                  type="button"
                  className="button px-3 py-1 bg-transparent border-0 text-white"
                  onClick={toggleAddTodo}
                >
                  {t("common.button.editTask")}
                </button>
                |
                <button
                  type="button"
                  className="button px-3 py-1 bg-transparent border-0 text-white"
                  onClick={onDeleteTodo}
                >
                  {t("common.button.delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isAddTodo && !isEditTodo && (
        <div className="card custom-card card-shadow rounded-2 border-0 mb-4">
          <div className="card-header d-flex flex-wrap align-items-center mb-2">
            <button
              type="button"
              className="bg-transparent border-0 me-2"
              onClick={onResetTodo}
            >
              <i className="bx bxs-left-arrow"></i>
            </button>
            <h3 className="card-title font-semibold">
              <input
                type="text"
                placeholder={t("common.placeHolder.task")}
                className="form-control"
                name="title"
                value={title}
                onChange={handleChange}
              />
            </h3>
            <div className="ms-auto d-flex align-items-center">
              <button
                type="button"
                className={`pin-button bg-transparent border-0 ms-auto ${
                  pin ? "active" : ""
                }`}
                onClick={handleChangePin}
              >
                <i className="bx bxs-pin"></i>
              </button>
            </div>
          </div>
          <div className="card-body">
            <div className="assigntask-header mb-3">
              <ul className="m-0 p-0 d-flex flex-wrap flex-xxl-nowrap gy-3">
                <li className="assigntask-box d-flex align-items-center me-4">
                  <div className="assigntast-icon d-flex justify-content-center align-items-center me-2">
                    <i className="bx bx-calendar bx-sm"></i>
                  </div>
                  <div className="assigntast-content">
                    <span className="assigntask-title d-block">
                      {t("common.label.dueOn")}
                    </span>
                    <input
                      type="date"
                      placeholder="Choose date"
                      className="form-control"
                      name="dueDate"
                      value={dueDate}
                      onChange={handleChange}
                    />
                  </div>
                </li>
                <li className="assigntask-box d-flex align-items-center">
                  <div className="assigntast-icon d-flex justify-content-center align-items-center me-2">
                    <i className="bx bx-bell bx-sm"></i>
                  </div>
                  <div className="assigntast-content">
                    <span className="assigntask-title d-block">
                      {t("common.label.reminder")}
                    </span>
                    <div className="form-check form-switch form-check-success">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="remainder"
                        name="remainder"
                        checked={remainder}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="assigntask-body mb-3">
              <div className="mb-4 p-3 rounded-3 bg-light">
                <textarea
                  id="description"
                  cols="30"
                  rows="6"
                  className="form-control bg-transparent"
                  placeholder={t("common.placeHolder.taskDetails")}
                  name="description"
                  value={description}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="add-sub-task-box">
                <h5>Add Sub-Task</h5>
                <input
                  type="text"
                  placeholder={t("common.placeHolder.subTask")}
                  className="form-control"
                  id="subTask"
                  name="subTask"
                  value={subTask}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="assigntask-footer d-flex justify-content-center">
              <div className="py-2 px-3 rounded-3 bg-dark text-white text-center">
                <button
                  type="button"
                  className="button px-3 py-1 bg-transparent border-0 text-white"
                  onClick={onSaveTodo}
                >
                  {t("common.button.saveTask")}
                </button>
                |
                <button
                  type="button"
                  className="button px-3 py-1 bg-transparent border-0 text-white"
                  onClick={onResetTodo}
                >
                  {t("common.button.cancel")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
